/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Settings_Reasoning_HighInputs */



/**
* | output |
* | --- |
* | "High" |
*
* @param {Model_Settings_Reasoning_HighInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_settings_reasoning_high = /** @type {((inputs?: Model_Settings_Reasoning_HighInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Settings_Reasoning_HighInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hoch")
	return /** @type {LocalizedString} */ ("High")
});